import cx from 'classnames';
import styles from 'partials/form-message.module.scss';

export const FormMessage = ({ text, type = 'error', className }) => {
	const boxClass = cx(styles.box, className, {
		[styles.boxRed]: type === 'error',
		[styles.boxBlue]: type === 'success'
	});

	return <div className={boxClass}>{text}</div>;
};
